import { Button, Col, Divider, Form, Row, Select } from 'antd';
import DropdownIcon from 'assets/icons/simulate-dropdown.svg';
import { RegistStepOnePayload } from 'domain/entities/UserEntity';
import { openErrorNoti } from 'presentation/components/Notification';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormRadio } from 'presentation/components/form/FormRadio.component';
import { FormSelect } from 'presentation/components/form/FormSelect.component';
import { FormTextArea } from 'presentation/components/form/FormTextArea.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import { StepProps } from '../props/StepProps';

const YES_NO_OPTIONS = [
    {
        label: 'あり',
        value: 1,
    },
    {
        label: 'なし',
        value: 0,
    },
];

const YES_NO_OPTIONS_DEPEND = [
    {
        label: 'あり',
        value: '10',
    },
    {
        label: 'なし',
        value: '20',
    },
];

const optionYear = Array.from(Array(51).keys()).map((item) => {
    return {
        label: item,
        value: item,
    };
});

const optionMonth = Array.from(Array(13).keys()).map((item) => {
    return {
        label: item,
        value: item,
    };
});

export const RegistrationStepOne = ({ 
    data,
    masterData,
    next,
    setIsChange,
    ...props
}: StepProps) => {
    const [btnDisable, setBtnDisable] = useState<boolean>(true);
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const [requiredOther1, setRequiredOther1] = useState<boolean>(false);
    const [requiredOther2, setRequiredOther2] = useState<boolean>(false);
    const [requiredDependent, setRequiredDependent] = useState<boolean>(false);
    const [requiredRelation, setRequiredRelation] = useState<boolean>(false);

    useEffect(() => {
        props.scrollTop && props.scrollTop();
    }, []);

    useEffect(() => {
        if (data && masterData) {
            form.setFieldsValue(data);
            setRequiredOther1(data.existFlagProperty === 1);
            setRequiredOther2(data.existFlagPropertyOther === 1);
            setRequiredRelation(data.existFlagRelation === 1);
            setRequiredDependent(data.existFlagRelation === 1 && data.dependentType === '10');
            onChangeForm();
        }
    }, [data, masterData]);

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    const changeBtnDisable = (isError: any) => {
        if (isError) {
            setBtnDisable(true);
        } else {
            onChangeForm();
        }
    };
    const submitNext = async () => {
        try {
            dispatch(startFetching());
            const formValues = form.getFieldsValue();
            let annualIncome;
            if(typeof formValues.annualIncome == 'number'){
                annualIncome = formValues.annualIncome;
            }else{
                annualIncome = Number(commonHelpers.replace(formValues.annualIncome || '0'));
            }

            const payload: RegistStepOnePayload = {
                existFlagProperty: formValues.existFlagProperty,
                existFlagPropertyOther: formValues.existFlagPropertyOther,
                existFlagRelation: formValues.existFlagRelation,
                homeBuildingType: formValues.homeBuildingType,
                homePossessionType: formValues.homePossessionType,
                housingLoanBalance: formValues.housingLoanBalance,
                livingTogetherCount: form.getFieldValue('livingTogetherCount'),
                dependentCountChild:form.getFieldValue('dependentCountChild'),
                dependentCountParent: form.getFieldValue('dependentCountParent'),
                dependentType: requiredRelation
                    ? Number(commonHelpers.replace(formValues.dependentType || '0'))
                    : 0,
                count01: Number(commonHelpers.replace(formValues.count01 || '0')),
                others01: formValues.others01,
                others02: formValues.others02,
                postalCode: formValues.postalCode,
                quantity01: Number(commonHelpers.replace(formValues.quantity01 || '0')),
                quantity02: Number(commonHelpers.replace(formValues.quantity02 || '0')),
                workplaceAddress: formValues.workplaceAddress,
                workplaceName: formValues.workplaceName,
                workplacePhoneNumber01: formValues.workplacePhoneNumber01,
                workplacePostalCode: formValues.workplacePostalCode,
                workplaceRole: formValues.workplaceRole,
                workplaceServiceMonths: formValues.workplaceServiceMonths || '0',
                workplaceServiceYears: formValues.workplaceServiceYears || '0',
                address: formValues.address,
                annualIncome: annualIncome,
            };
            const response = await props.userUseCase.regsitUserStep1(payload);
            if (response) {
                next && next();
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <>
            <Form
                form={form}
                onValuesChange={() => {
                    onChangeForm();
                    setIsChange && setIsChange(true);
                }}
                onFinish={submitNext}
            >
                <Row className="min-w-min">
                    <div className="w-full mb-[48px]">
                        <span className="content-step-form heading-step-form">自宅</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="郵便番号（ハイフンなし）"
                                    name="postalCode"
                                    required
                                    maxLength={7}
                                    formatNumber={false}
                                    type="number"
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="住所"
                                    name="address"
                                    required
                                    maxLength={100}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="w-full mb-[48px]">
                        <span className="content-step-form heading-step-form">勤務先</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="勤務先名称"
                                    name="workplaceName"
                                    required
                                    maxLength={100}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="勤務先の郵便番号（ハイフンなし）"
                                    name="workplacePostalCode"
                                    required
                                    type="postcode"
                                    maxLength={7}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="勤務先の所在地"
                                    name="workplaceAddress"
                                    required
                                    maxLength={100}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="勤務先での役職"
                                    name="workplaceRole"
                                    required
                                    maxLength={100}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="勤務先の連絡先（ハイフンなし）"
                                    name="workplacePhoneNumber01"
                                    required
                                    type="phone"
                                    maxLength={12}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <span className="content-step-form label-step-form">
                                    勤続年数<span style={{ color: '#EB5757' }}>*</span>
                                </span>
                                <Row>
                                    <Col span={10}>
                                        <Form.Item name="workplaceServiceYears">
                                            <Select
                                                size="large"
                                                className="select-custom "
                                                defaultValue={0}
                                                suffixIcon={
                                                    <img src={DropdownIcon} alt="dropdown icon" />
                                                }
                                                options={optionYear}
                                                placeholder={PLACEHOLDER.SELECT}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col
                                        span={2}
                                        className="flex justify-center min-w-fit my-[5px] mt-[12px] "
                                    >
                                        年
                                    </Col>
                                    <Col span={9}>
                                        <Form.Item name="workplaceServiceMonths">
                                            <Select
                                                size="large"
                                                className="select-custom"
                                                defaultValue={0}
                                                options={optionMonth}
                                                suffixIcon={
                                                    <img src={DropdownIcon} alt="dropdown icon" />
                                                }
                                                placeholder={PLACEHOLDER.SELECT}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col
                                        span={3}
                                        className="flex justify-center min-w-fit my-[5px] mt-[12px] "
                                    >
                                        ヶ月
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="直近の年収"
                                    name="annualIncome"
                                    type="number"
                                    required
                                    maxLength={7}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="万円"
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="w-full mb-[48px]">
                        <span className="content-step-form heading-step-form">家族</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormRadio
                                    label="配偶者"
                                    name="existFlagRelation"
                                    options={YES_NO_OPTIONS}
                                    required
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredRelation(e == '1');
                                    }}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormRadio
                                    label="配偶者の扶養義務"
                                    name="dependentType"
                                    options={YES_NO_OPTIONS_DEPEND}
                                    required={requiredRelation}
                                    disabled={!requiredRelation}
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredDependent(requiredRelation && e == '10');
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="子供"
                                    name="count01"
                                    type="number"
                                    maxLength={2}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                    required
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="扶養の子供"
                                    name="dependentCountChild"
                                    required
                                    type="number"
                                    maxLength={2}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="同居している子供"
                                    name="livingTogetherCount"
                                    required
                                    type="number"
                                    maxLength={2}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="扶養している父母"
                                    name="dependentCountParent"
                                    required
                                    type="number"
                                    maxLength={2}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="w-full mb-[48px]">
                        <span className="content-step-form heading-step-form">その他</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormSelect
                                    options={
                                        masterData?.[
                                            MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION
                                        ]
                                    }
                                    label="自宅の建物区分"
                                    required
                                    name="homeBuildingType"
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormSelect
                                    options={
                                        masterData?.[
                                            MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION
                                        ]
                                    }
                                    label="自宅の所有区分"
                                    name="homePossessionType"
                                    required
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="住宅ローン残債"
                                    name="housingLoanBalance"
                                    type="number"
                                    required
                                    maxLength={9}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="万円"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormRadio
                                    options={YES_NO_OPTIONS}
                                    required
                                    label="投資用不動産"
                                    name="existFlagProperty"
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredOther1(e == '1');
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="区分マンション（戸数）"
                                    name="quantity01"
                                    type="number"
                                    required={requiredOther1}
                                    disabled={!requiredOther1}
                                    maxLength={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="戸"
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="一棟アパート・戸建て（棟数）"
                                    name="quantity02"
                                    type="number"
                                    required={requiredOther1}
                                    disabled={!requiredOther1}
                                    maxLength={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="棟"
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={24}>
                                <FormTextArea
                                    label="投資用不動産詳細（任意）"
                                    name="others01"
                                    disabled={!requiredOther1}
                                    maxLength={1000}
                                    rows={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12}>
                                <FormRadio
                                    options={YES_NO_OPTIONS}
                                    required
                                    label="その他所有不動産"
                                    name="existFlagPropertyOther"
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredOther2(e == '1');
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row gutter={[0, 12]}>
                            <Col span={24}>
                                <FormTextArea
                                    label="その他所有不動産詳細"
                                    name="others02"
                                    required={requiredOther2}
                                    disabled={!requiredOther2}
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                    maxLength={1000}
                                    rows={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row justify="center" className="w-full mb-6">
                        <Col span={12} style={{ paddingLeft: '8px' }}>
                            <Button
                                type="primary"
                                size="large"
                                disabled={btnDisable}
                                onClick={() => {
                                    submitNext();
                                }}
                                className="button-container"
                            >
                                登録する
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </Form>
        </>
    );
};
